var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.view === "list",
              expression: "view==='list'"
            }
          ],
          staticClass: "main-content"
        },
        [
          _c(
            "search-item",
            {
              ref: "searchItem",
              attrs: {
                "config-module": "9212",
                "is-simple-query": false,
                "custom-sim-query-placeholder":
                  _vm.$t("CargoMsg.Cargo_PlsInput") +
                  ":" +
                  _vm.$t("CargoMsg.Cargo_AssemblyPlanNumber"),
                "custom-search-items": _vm.customSearchItems
              },
              on: {
                "click-more": function(value) {
                  _vm.isAdvancedQuery = value
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.queryHandler
              }
            },
            [
              _c(
                "div",
                { attrs: { slot: "operations" }, slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", disabled: !_vm.selectedRow },
                      on: { click: _vm.detail }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_View")))]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { staticStyle: { "flex-grow": "1", "min-height": "350px" } },
            [
              _c("cargo-ag-grid-wrapper", {
                staticStyle: { height: "100%" },
                attrs: {
                  "config-module": "202206074",
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "show-selected-color": false,
                  "check-sub-record": false
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "202206074",
                  total: _vm.filter.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.fetchDataByPage
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.view === "detail"
        ? _c("assembly-plan-detail", {
            ref: "assemblyPlanDetail",
            attrs: {
              "airline-product-down-list": _vm.airlineProductDownList,
              "assembly-plan-uuid": _vm.selectedRow.uuid
            },
            on: {
              saveAssemblyPlanSuccess: function(assemblyPlanUuid) {
                return _vm.$emit("saveAssemblyPlanSuccess", assemblyPlanUuid)
              },
              back: function($event) {
                _vm.view = "list"
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }